<label class="form-label" [innerHTML]="label"></label>
<button [class.disabled]="!HasPrev()" (click)="Prev()" type="button" class="btn btn-sm square btn-primary">
  <span class="fas fa-caret-left"></span>
</button>
<button [class.disabled]="!HasNext()" (click)="Next()" type="button" class="btn btn-sm square btn-primary">
  <span class="fas fa-caret-right"></span>
</button>
<span [innerHTML]="start"></span><span>-</span>
<span [innerHTML]="end"></span>
<span>of</span>
<span [innerHTML]="count"></span>

